import store from './store';

export async function getToken(manufacturer, forceToken = false) {

  if( !forceToken && (window.location.href == 'https://myorder.ndtec.local/#/' || window.location.href == 'https://myorder.ndtecsdevel.co.za/#/' || window.location.href == 'https://myorder.ndtecstaging.co.za/#/' || window.location.href == 'https://myorder.ndtec.co.za/#/' || window.location.href.includes('#/login') || window.location.href.includes('#/customer-setup')) ) {
    return true;
  } else if( window.location.href.includes('#/survey') ) {

    const hash = window.location.hash;
    const queryString = hash.includes('?') ? hash.split('?')[1] : '';

    const urlParams = new URLSearchParams(queryString);

    if( window.location.href.includes('agentEmail') ) {
      var cachedToken = '';
      const userEmail = urlParams.get('agentEmail');
      try {
        const response = await fetch(window.location.protocol + process.env.API_ENDPOINT + 'System.php?a=generate_token_service_form_agent', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            manufacturer: manufacturer,
            setcookie: false,
            user: userEmail
          }),
        });

        if (!response.ok) {
          throw new Error('Failed to fetch token');
        }

        let data = await response.json();
        //data = JSON.parse( data );

        cachedToken = data.token;

        return cachedToken;
      } catch (error) {
        console.error('Token fetch error:', error);
        return null;
      }
    } else {
      var cachedToken = '';
      const userEmail = urlParams.get('customer');
      try {
        const response = await fetch(window.location.protocol + process.env.API_ENDPOINT + 'System.php?a=generate_token_service_form', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            manufacturer: manufacturer,
            setcookie: false,
            user: userEmail
          }),
        });

        if (!response.ok) {
          throw new Error('Failed to fetch token');
        }

        let data = await response.json();
        //data = JSON.parse( data );

        cachedToken = data.token;

        return cachedToken;
      } catch (error) {
        console.error('Token fetch error:', error);
        return null;
      }
    }

  } else {

    //var objAuth = JSON.parse(rootState.objAuthorize);

    var cachedToken = '';
    try {
      const response = await fetch(window.location.protocol + process.env.API_ENDPOINT + 'System.php?a=generate_token_myorder', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          manufacturer: manufacturer
        }),
      });

      if (!response.ok) {
        throw new Error('Failed to fetch token');
      }

      let data = await response.json();
      //data = JSON.parse( data );

      cachedToken = data.token;

      return cachedToken;
    } catch (error) {
      console.error('Token fetch error:', error);
      return null;
    }

  }

}
